<template>
  <v-card>
    <div class="py-4 px-4 d-flex justify-center align-center">
      <v-icon large> {{ icone }}</v-icon>
      <h2 class="justify-center">{{ title }}</h2>

      <v-spacer />
      <v-btn color="primary" icon @click="close">
        <v-icon size="24" color="#ccc">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card-text class="px-6">
      <span class="label">
        {{ textMessage }}
      </span>
      <br />
      <span class="label">
        Para isso baixe o nosso modelo e preencha da forma que melhor te
        atender.
      </span>
    </v-card-text>

    <v-card-actions>
      <v-row class="ma-0">
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
            height="60"
            class="secondary-button"
            width="100%"
            @click="action3"
            elevation="0"
            target="_blank"
            dark
          >
            Baixar Modelo
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="6">
          <v-btn
            height="60"
            width="100%"
            class="primary-button"
            elevation="0"
            dark
            @click="openFilePicker"
            :loading="loading"
          >
            <span>Importar Excel</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>

    <input
      id="excelInput"
      name="excelInput"
      ref="excelInput"
      type="file"
      accept=".xlsx,.xlsm"
      style="display: none"
      @change="setExcelFile"
    />
  </v-card>
</template>

<style scoped>
.label {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.2px;
  color: #232021;
}
</style>

<script scoped>
import ApiService from "../../../services/ApiService";
import Vue from "vue";

export default {
  name: "ImportExcel",

  props: {
    textMessage: String,
    icone: String,
    title: String,
    route: String,
    tipo: String,
    typeRoute: String,
  },

  data: () => ({
    loading: false,
    apiService: new ApiService(),
  }),

  computed: {},

  methods: {
    action3() {
      this.$emit("importExc");
    },

    action() {
      this.$emit("action");
    },

    close() {
      this.$emit("close");
    },

    openFilePicker() {
      document.querySelector("#excelInput").click();
    },

    setExcelFile(event) {
      this.loading = true;
      let file;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        file = reader.result;
        this.apiService
          .post(this.route + "/excel-import", { file: file })
          .then((resp) => {
            this.$forceUpdate();
            this.$emit("update");
            this.loading = false;
            this.$emit("close");
            this.close();
            this.$toast.success("Importação feita com sucesso");
            this.action();
          })
          .catch((erro) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao importar o arquivo",
              message: erro.body.message,
              trace: null,
            });
            this.loading = false;
          });
      };
    },
  },
};
</script>
